import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ci-cd',
  templateUrl: './ci-cd.component.html',
  styleUrls: ['./ci-cd.component.scss']
})
export class CICDComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
